"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var input_1 = require("../input");

exports.default = function (_a) {
  var className = _a.className,
      value = _a.value,
      onChange = _a.onChange,
      label = _a.label;
  return react_1.default.createElement("div", {
    className: className
  }, react_1.default.createElement("h4", {
    className: 'my-4 text-center'
  }, label), react_1.default.createElement("div", {
    className: 'row'
  }, react_1.default.createElement("div", {
    className: 'offset-xs-2 col-xs-8 col-sm-12'
  }, react_1.default.createElement("div", {
    className: 'input-group my-4'
  }, react_1.default.createElement("input", {
    autoFocus: true,
    value: value,
    onChange: input_1.getTargetValue(onChange),
    id: 'password',
    type: 'password',
    name: 'password',
    placeholder: 'Password',
    className: 'w-50 form-control bg-transparent'
  }), react_1.default.createElement("div", {
    className: 'input-group-append p-2'
  }, react_1.default.createElement("i", {
    className: 'fa fa-key text-secondary'
  }))))));
};